import { render, staticRenderFns } from "./customForm.vue?vue&type=template&id=64d8de31&scoped=true"
import script from "./customForm.vue?vue&type=script&lang=js"
export * from "./customForm.vue?vue&type=script&lang=js"
import style0 from "./customForm.vue?vue&type=style&index=0&id=64d8de31&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8de31",
  null
  
)

export default component.exports